import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=7eaf97b2&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=7eaf97b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf97b2",
  null
  
)

export default component.exports